import React from 'react';

import {
  Description,
  EmptyStateSize,
  IconSlot,
  StyledEmptyState,
  Title,
} from './styles';

export type EmptyStateProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  size?: EmptyStateSize;
  color?: string;
};

const EmptyState = ({
  title,
  description,
  icon,
  size = 'md',
  color,
  children,
  ...rest
}: EmptyStateProps): JSX.Element => {
  return (
    <StyledEmptyState $size={size} $color={color} {...rest}>
      {icon && <IconSlot>{icon}</IconSlot>}
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
      {children}
    </StyledEmptyState>
  );
};

export default EmptyState;
